import * as React from 'react'
// types
import { IRiskView } from 'types/graphql'

type Props = React.PropsWithChildren<unknown>

interface IContext {
  riskView: IRiskView
  isScheduled: boolean
  selectRiskView: (riskView: IRiskView) => void
  showScheduledRisks: () => void
}

export const RiskRegisterContext = React.createContext<IContext>({} as any)

const RiskRegisterProvider: React.FC<Props> = ({ children }) => {
  const [riskView, setRiskVew] = React.useState<IRiskView | null>(null)
  const [isScheduled, setIsScheduled] = React.useState(JSON.parse(localStorage.getItem('scheduled')) || false)

  const showScheduledRisks = () => {
    setIsScheduled((prev) => !prev)
    localStorage.setItem('scheduled', JSON.stringify(!isScheduled))
  }

  const selectRiskView: IContext['selectRiskView'] = (riskView) => {
    setRiskVew(riskView)
  }

  return (
    <RiskRegisterContext.Provider value={{ riskView, isScheduled, selectRiskView, showScheduledRisks }}>
      {children}
    </RiskRegisterContext.Provider>
  )
}

export default RiskRegisterProvider
